import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendar, faFolderOpen, faPersonChalkboard, faMap, faMapLocation, faHome, faInfoCircle, faLink } from '@fortawesome/free-solid-svg-icons'
import { faCalendar as farCalendar, faFolderOpen as farFolderOpen, faMap as farMap, faMapLocation as farMapLocation, faHome as farHome, faInfoCircle as farInfoCircle } from '@fortawesome/free-regular-svg-icons'

const iconStyle = { fontSize: "85px", color: '#466580' }

export const BigCalendarIcon = () => <FontAwesomeIcon icon={farCalendar} {...iconStyle} />
export const BigMapIcon = () => <FontAwesomeIcon icon={faMapLocation}        {...iconStyle} />
export const BigChartIcon = () => <FontAwesomeIcon icon={faPersonChalkboard} {...iconStyle} />

export const CalendarIcon = () => <FontAwesomeIcon icon={farCalendar} className='pe-1' fontSize="large" />
export const MapIcon = () => <FontAwesomeIcon icon={faMapLocation} className='pe-1' fontSize="large"  />
export const ChartIcon = () => <FontAwesomeIcon icon={faPersonChalkboard} className='pe-1' fontSize="large"  />
export const HomeIcon = () => <FontAwesomeIcon icon={faHome} className='pe-1' fontSize="large"  />
export const InfoIcon = () => <FontAwesomeIcon icon={faInfoCircle} className='pe-2' fontSize="large"  />
export const LinkIcon = () => <FontAwesomeIcon icon={faLink} />

